
import { Component, mixins } from 'nuxt-property-decorator';
import TiptapEditorMixin from './TiptapEditorMixin';

@Component
export default class TiptapEditor extends mixins(TiptapEditorMixin) {}
